import { Action } from '@ngrx/store';

import { OrganizationWithToken, SelectedOrganizationRequest } from '../models/core';

export enum CoreActionTypes {
  SelectOrganization = '[Core] Select Organization',
  SelectOrganizationSuccess = '[Core] Selected Organization Success',
  SelectOrganizationFail = '[Core] Selected Organization Fail',
  ClearState = '[Core] Clear State'
}

export class SelectOrganization implements Action {
  readonly type = CoreActionTypes.SelectOrganization;

  constructor(public payload: SelectedOrganizationRequest) {}
}

export class SelectOrganizationSuccess implements Action {
  readonly type = CoreActionTypes.SelectOrganizationSuccess;

  constructor(public payload: OrganizationWithToken) {}
}

export class SelectOrganizationFail implements Action {
  readonly type = CoreActionTypes.SelectOrganizationFail;

  constructor(public payload: string) {}
}

export class ClearState implements Action {
  readonly type = CoreActionTypes.ClearState;
}

export type CoreActions =
  | SelectOrganization
  | SelectOrganizationSuccess
  | SelectOrganizationFail
  | ClearState;
